export const adminTheme = {
  colors: {
    sidebarBg: '#202D61',
    sidebarText: '#ffffff',
    sidebarHover: 'rgba(255, 255, 255, 0.1)',
    sidebarActive: 'rgba(255, 255, 255, 0.15)',
    primary: '#1a73e8',
    primaryHover: '#1557b0',
    danger: '#d93025',
    dangerHover: '#b3261e',
    success: '#0d652d',
    warning: '#e37400',
    headerBg: '#ffffff',
    contentBg: '#f5f5f5',
    cardBg: '#ffffff',
    border: '#e8eaed',
    text: '#202124',
    textSecondary: '#5f6368',
    textMuted: '#9aa0a6',
    rowAlt: '#f8f9fa',
  },
  spacing: {
    sidebar: 220,
    header: 48,
    pagePadding: 24,
  },
  borderRadius: '8px',
  shadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
};

export const statusColors: Record<string, { bg: string; text: string }> = {
  new: { bg: '#e8f0fe', text: '#1a73e8' },
  contacted: { bg: '#fef7e0', text: '#e37400' },
  quoted: { bg: '#e6f4ea', text: '#0d652d' },
  won: { bg: '#ceead6', text: '#0d652d' },
  lost: { bg: '#fce8e6', text: '#d93025' },
};
